import React from 'react'
import Nav from './Nav'

const Help = () => {
  return (
    <div>
      <Nav />
      <section>
        <h1>Help</h1>
      </section>
    </div>
  )
}

export default Help
